// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom__row {
  height: 10vh;
  margin: 20px 0 10px 20px;
}

.customn__wrapper {
  margin-left: 20px;
  display: flex;
}

.custom__wrapper__container {
  display: flex;
}

.custom__wrapper__box {
  margin: 0 2rem 1rem 0
}

.custom__wrapper__text {
  /* margin: 1rem 0 0 1rem; */
  border-left: 1px solid gray;
  border-radius: 0;
  padding-left: 2rem;
  height: 13rem;
  padding-top: 2rem;
}

.custom__wrapper__title {
  padding: 5px 0px;
  margin: 0;
  font-size: var(--title);
}

.custom__wrapper__autocomplete__title {
  font-family: 'Segoe UI';
  font-style: normal;
  font-weight: normal;
  font-size: var(--title);
  margin: 1rem 0 0.5rem 0;
}

.custom__autocomplete {
  width: 300px;
}

.disabledCustom {
  background: rgb(238, 237, 237);
}

.custom__autocomplete div div div {
  top: 0 !important
}

.custom__autocomplete div div input {
  padding: 0 0 0 10px!important;
  height: 35px !important;
}

.custom__autocomplete div div{
  padding: 5px !important;
}

.text__field__container {
  border-radius: 5px;
  width: 300px;
  color: rgb(199 198 197);
}

.text__field__container:first-child {
  margin: 0 0 5px 0 !important;
}

.text__field__container div input {
  padding: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/RulesConfiguration/components/createTab/Custom/CustomRC.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".custom__row {\n  height: 10vh;\n  margin: 20px 0 10px 20px;\n}\n\n.customn__wrapper {\n  margin-left: 20px;\n  display: flex;\n}\n\n.custom__wrapper__container {\n  display: flex;\n}\n\n.custom__wrapper__box {\n  margin: 0 2rem 1rem 0\n}\n\n.custom__wrapper__text {\n  /* margin: 1rem 0 0 1rem; */\n  border-left: 1px solid gray;\n  border-radius: 0;\n  padding-left: 2rem;\n  height: 13rem;\n  padding-top: 2rem;\n}\n\n.custom__wrapper__title {\n  padding: 5px 0px;\n  margin: 0;\n  font-size: var(--title);\n}\n\n.custom__wrapper__autocomplete__title {\n  font-family: 'Segoe UI';\n  font-style: normal;\n  font-weight: normal;\n  font-size: var(--title);\n  margin: 1rem 0 0.5rem 0;\n}\n\n.custom__autocomplete {\n  width: 300px;\n}\n\n.disabledCustom {\n  background: rgb(238, 237, 237);\n}\n\n.custom__autocomplete div div div {\n  top: 0 !important\n}\n\n.custom__autocomplete div div input {\n  padding: 0 0 0 10px!important;\n  height: 35px !important;\n}\n\n.custom__autocomplete div div{\n  padding: 5px !important;\n}\n\n.text__field__container {\n  border-radius: 5px;\n  width: 300px;\n  color: rgb(199 198 197);\n}\n\n.text__field__container:first-child {\n  margin: 0 0 5px 0 !important;\n}\n\n.text__field__container div input {\n  padding: 14px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
